import React from 'react';
import { getI18n } from 'react-i18next';
import moment from 'moment';
import DatePickerEnglish from './DatePickerEnglish';
import DatePickerRomanian from './DatePickerRomanian';
import DatePickerGerman from './DatePickerGerman';

const DatePickerLocale = (props) => {
  const { language } = getI18n();
  const { maxOffSetDays } = props;

  const disabledDate = (current) => {
    return (
      current.isBefore(moment(), 'day') ||
      Date.parse(current) > Date.parse(moment().add(maxOffSetDays, 'days'))
    );
  };

  const enhancedProps = {
    ...props,
    ...(maxOffSetDays && { disabledDate }),
  };

  switch (language) {
    case 'en':
      return <DatePickerEnglish {...enhancedProps} />;
    case 'de':
      return <DatePickerGerman {...enhancedProps} />;
    default:
      return <DatePickerRomanian {...enhancedProps} />;
  }
};
export default DatePickerLocale;
